import { jsPDF } from "jspdf";
import { loadCustomFontFiraSansLight } from "../assets/fonts/FiraSans-Light-normal"; //base64 de la fuente
import { loadCustomFontFiraSansSemibold } from "../assets/fonts/FiraSans-SemiBold-normal"; //base64 de la fuente
import { loadCustomFontFiraSansRegular } from "../assets/fonts/FiraSans-Regular-normal"; //base64 de la fuente
import { loadB64FeatureIcon1, loadB64FeatureIcon2, loadB64FeatureIcon3, loadB64FeatureIcon4 } from "./pdfImgs";
import i18n from 'i18next';;


function addTitleAndTextData(doc, text, previousY = 35, textFontSize = 15) {
  const lineSpacing = 8; // Espacio constante entre líneas
  const gap = 6;
  const maxWidth = 173;
  let newY = previousY !== 0 ? previousY + gap : 20;
  let textY = newY;
  let currentLineWidth = 0; // Ancho actual de la línea
  let firstWordInPart = true; // Indica si es la primera palabra en una parte del texto

  const boldMarker = '**'; // Marcador para texto en negrita
  const parts = text.split(boldMarker);
  let isBold = false; // Controla si el texto está en negrita

  doc.setFontSize(textFontSize);

  parts.forEach(part => {
    if (isBold) {
      doc.setFont("FiraSans-SemiBold");
    } else {
      doc.setFont("FiraSans-Regular");
    }

    const words = part.split(" ");
    words.forEach((word, wordIndex) => {
      let wordWithSpace;

      if (currentLineWidth === 0 || firstWordInPart) {
        wordWithSpace = word; // Sin espacio si es el inicio de una línea o parte
        firstWordInPart = false; // Ya no es la primera palabra de la parte
      } else {
        wordWithSpace = " " + word;
      }

      const wordWidth = doc.getTextWidth(wordWithSpace);

      if (currentLineWidth + wordWidth > maxWidth) {
        textY += lineSpacing;
        currentLineWidth = 0;
        // Si la palabra es la primera de una nueva línea, no añadir espacio
        doc.text(word, 20, textY);
        currentLineWidth = doc.getTextWidth(word);
        firstWordInPart = false; // La siguiente palabra no será la primera de una parte
      } else {
        doc.text(wordWithSpace, 20 + currentLineWidth, textY);
        currentLineWidth += wordWidth;
      }
    });

    isBold = !isBold; // Cambia el estado de negrita para la próxima parte
    firstWordInPart = true; // Reinicia para la próxima parte
  });

  return textY + lineSpacing; // Devuelve la nueva posición Y después del último texto
}


function writeTextWithLineBreaks(doc, text, startX, startY, maxWidth = 160) {
  const lineSpacing = 6; // Espacio constante entre líneas


  const words = text.split(" ");
  let currentY = startY;
  let currentLine = "";

  words.forEach(word => {
    const testLine = currentLine + word + " ";
    const testLineWidth = doc.getTextWidth(testLine);

    if (testLineWidth > maxWidth && currentLine !== "") {
      doc.text(currentLine, startX, currentY);
      currentLine = word + " ";
      currentY += lineSpacing;
    } else {
      currentLine = testLine;
    }
  });

  if (currentLine !== "") {
    doc.text(currentLine, startX, currentY);
  }

  return currentY;
}



export const downloadCertificationCardPresentation = (data, lang, qr) => {
  const firaSansLightB64 = loadCustomFontFiraSansLight();
  const firaSansSemiboldB64 = loadCustomFontFiraSansSemibold();
  const firaSansRegularB64 = loadCustomFontFiraSansRegular();
  const feature1IMG = loadB64FeatureIcon1();
  const feature2IMG = loadB64FeatureIcon2();
  const feature3IMG = loadB64FeatureIcon3();
  const feature4IMG = loadB64FeatureIcon4();
  const QRImg = qr;


  const doc = new jsPDF();


  //AÑADIR FUENTES PERSONALIZADAS
  doc.addFileToVFS('FiraSans-Light-normal.ttf', firaSansLightB64);
  doc.addFileToVFS('FiraSans-SemiBold-normal.ttf', firaSansSemiboldB64);
  doc.addFileToVFS('FiraSans-Regular-normal.ttf', firaSansRegularB64);
  doc.addFont('FiraSans-Light-normal.ttf', 'FiraSans-Light', 'normal');
  doc.addFont('FiraSans-SemiBold-normal.ttf', 'FiraSans-SemiBold', 'normal');
  doc.addFont('FiraSans-Regular-normal.ttf', 'FiraSans-Regular', 'normal');




  // variables del documento
  const text1 = `${i18n.t("incidents:pdfIncident.secretSaveDoc")}`;
  const maxWidth1 = 160;
  const imgWidth = 50; // Ancho de la imagen de la empresa en el pdf
  const imgHeight = 12;
  const bigFontSize = 15;
  const smallFontSize = 12;
  const linkFontSize = 13;
  // Calcula el ancho de la página
  const pageWidth = doc.internal.pageSize.getWidth();

  // Calcula la posición X para centrar la imagen
  const imgX = (pageWidth - imgWidth) / 2;


  doc.addImage(data.imageData, "PNG", imgX, 15, imgWidth, imgHeight);
  doc.setFontSize(bigFontSize);
  doc.setFont("FiraSans-Light", "normal");


  let yCoordinate = 30;
  yCoordinate = addTitleAndTextData(doc, `${i18n.t("certificate:certificatePDF.text1")}`);
  yCoordinate = addTitleAndTextData(doc, `${i18n.t("certificate:certificatePDF.text2")}`, yCoordinate);

  //SEPARADOR A FEATURES
  yCoordinate += 5
  doc.setDrawColor(211, 211, 211)
  doc.setLineWidth(0.2)
  doc.line(20, yCoordinate, 190, yCoordinate);
  yCoordinate += 12
  let title = `${i18n.t("certificate:certificatePDF.titleFeatures")}`;
  let feature1 = `${i18n.t("certificate:certificatePDF.feature1")}`;
  let feature2 = `${i18n.t("certificate:certificatePDF.feature2")}`;
  let feature3 = `${i18n.t("certificate:certificatePDF.feature3")}`;
  let feature4 = `${i18n.t("certificate:certificatePDF.feature4")}`;

  // Calcula el ancho del texto
  const textWidth = doc.getTextWidth(title);
  // Calcula la posición x para centrar el texto
  const x = (pageWidth / 2) - (textWidth / 2);

  doc.text(title, x, yCoordinate);

  //FEATURES
  doc.setFontSize(smallFontSize);

  yCoordinate += 8
  doc.addImage(feature1IMG, "PNG", 20, yCoordinate, 6, 6);
  yCoordinate += 5
  yCoordinate = writeTextWithLineBreaks(doc, feature1, 30, yCoordinate)

  yCoordinate += 6
  doc.addImage(feature2IMG, "PNG", 20, yCoordinate, 6, 6);
  yCoordinate += 5
  yCoordinate = writeTextWithLineBreaks(doc, feature2, 30, yCoordinate)

  yCoordinate += 6
  doc.addImage(feature3IMG, "PNG", 20, yCoordinate, 6, 6);
  yCoordinate += 5
  yCoordinate = writeTextWithLineBreaks(doc, feature3, 30, yCoordinate)

  yCoordinate += 6
  doc.addImage(feature4IMG, "PNG", 20, yCoordinate, 6, 6);
  yCoordinate += 5
  yCoordinate = writeTextWithLineBreaks(doc, feature4, 30, yCoordinate)

  doc.setFontSize(bigFontSize);

  //SEPARADOR A LINK
  let accessTitle = `${i18n.t("certificate:certificatePDF.access")}`;

  yCoordinate += 12;
  doc.line(20, yCoordinate, 190, yCoordinate);
  yCoordinate += 10;

  // Calcula el ancho del texto
  const textWidth0 = doc.getTextWidth(accessTitle);
  // Calcula la posición x para centrar el texto
  const x0 = (pageWidth / 2) - (textWidth0 / 2);


  doc.text(accessTitle, x0, yCoordinate);
  yCoordinate += 10;

  //Cambiar estilos
  doc.setFont("FiraSans-SemiBold");
  doc.setFontSize(linkFontSize);

  //Calcular para centrar texto
  const textWidth1 = doc.getTextWidth(data.publicLink);
  const x1 = (pageWidth / 2) - (textWidth1 / 2);

  doc.text(data.publicLink, x1, yCoordinate);
  doc.setDrawColor(0, 0, 0)
  doc.line(x1, (yCoordinate + 1), (x1 + textWidth1), (yCoordinate + 1));
  //Cambiar estilos
  doc.setFontSize(bigFontSize);
  doc.setFont("FiraSans-Regular");



  //SEPARADOR A QR
  let qrTitle = `${i18n.t("certificate:certificatePDF.qrAccess")}`;
  let qrTitle2 = `${i18n.t("certificate:certificatePDF.qrAccess2")}`;



  yCoordinate += 12
  doc.setDrawColor(211, 211, 211)
  doc.line(20, yCoordinate, 190, yCoordinate);
  yCoordinate += 8

  // Calcula el ancho del texto
  const textWidth2 = doc.getTextWidth(qrTitle);
  const textWidth3 = doc.getTextWidth(qrTitle2);
  // Calcula la posición x para centrar el texto
  const x2 = (pageWidth / 2) - (textWidth2 / 2);
  const x3 = (pageWidth / 2) - (textWidth3 / 2);
  yCoordinate = writeTextWithLineBreaks(doc, qrTitle, x2, yCoordinate)
  yCoordinate += 8
  yCoordinate = writeTextWithLineBreaks(doc, qrTitle2, x3, yCoordinate)


  yCoordinate += 5
  doc.addImage(QRImg, "PNG", (pageWidth - 40) / 2, yCoordinate, 40, 40);
  yCoordinate += 30


  //SEPARADOR A APUNTE

  let reminder = `${i18n.t("certificate:certificatePDF.reminder")}`;
  let reminder2 = `${i18n.t("certificate:certificatePDF.reminder2")}`;


  doc.setFontSize(linkFontSize);
  const textWidth4 = doc.getTextWidth(reminder);
  const textWidth5 = doc.getTextWidth(reminder2);
  const x4 = (pageWidth / 2) - (textWidth4 / 2);
  const x5 = (pageWidth / 2) - (textWidth5 / 2);

  yCoordinate += 12
  doc.line(20, yCoordinate, 190, yCoordinate);

  doc.setFont("FiraSans-SemiBold");
  yCoordinate += 8
  yCoordinate = writeTextWithLineBreaks(doc, reminder, x4, yCoordinate, 170)
  yCoordinate += 5
  yCoordinate = writeTextWithLineBreaks(doc, reminder2, x5, yCoordinate, 170)




  doc.save(`${i18n.t("certificate:certificatePDF.title")}.pdf`);
  /*  const pdfBlob = doc.output("blob");
   const pdfURL = URL.createObjectURL(pdfBlob);
 
   return pdfURL */

};

